<template>
  <template v-if="empty">
    <a
      class="d-flex justify-content-between align-items-center"
      :class="{ active: isActive }"
      href="#"
      :data-tooltip="tooltipText"
      @click.prevent="$emit('open')"
    >
      <span class="sidebar-link-content">
        <i
          v-if="icon"
          class="bi"
          :class="icon"
        ></i>
        <span class="sidebar-link-text">{{ linkTitle }}</span>
      </span>
      <i
        v-if="icon"
        class="bi bi-caret-down-fill"
      ></i>
    </a>
  </template>
  <template v-else>
    <RouterLink
      :to="linkTo"
      custom
      v-slot="{ href }"
    >
      <a
        :href="disabled ? undefined : href"
        :class="{
          active: isActive && !disabled,
          disabled,
          'pe-none': disabled,
          'opacity-50': disabled,
        }"
        :aria-disabled="disabled ? 'true' : undefined"
        :tabindex="disabled ? -1 : undefined"
        :data-tooltip="tooltipText"
        @click="handleRouteClick"
      >
        <span class="sidebar-link-content">
          <i
            v-if="icon"
            class="bi"
            :class="icon"
          ></i>
          <span class="sidebar-link-text">{{ linkTitle }}</span>
        </span>
      </a>
    </RouterLink>
  </template>
</template>
<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'
import { isSidebarRouteActive } from '@/lib/sidebarActive'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const { sidebarIconOnly } = storeToRefs(useUiStore())

const props = defineProps({
  item: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  empty: {
    type: Boolean,
    default: false,
  },
  /** Force active (e.g. parent when a child route is current). */
  forceActive: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['open'])

const icon = computed(() => (props.item.meta?.icon ? `bi-${props.item.meta.icon}` : null))
const linkTitle = computed(() => {
  const meta = props.item.meta || {}
  if (meta.titleKey) {
    return t(meta.titleKey)
  }
  return meta.title || ''
})
const disabled = computed(() => props.item.meta?.disabled)
const tooltipText = computed(() => (sidebarIconOnly.value ? linkTitle.value : undefined))

/** Path first — href never inherits current page query (e.g. /taxes?page=…). */
const linkTo = computed(() => {
  const path = props.item?.path
  if (typeof path === 'string' && path.startsWith('/')) {
    return path
  }
  if (props.item?.name) {
    return { name: props.item.name }
  }
  return '/'
})

const isActive = computed(
  () =>
    props.forceActive || isSidebarRouteActive(route.name, props.item?.name)
)

/**
 * Навигация через router.push по name/path без query текущего списка.
 */
function handleRouteClick(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.altKey ||
    event.ctrlKey ||
    event.shiftKey
  ) {
    return
  }
  event.preventDefault()
  const target = linkTo.value
  if (!target || target === '/') return
  router.push(target).catch(() => {})
}
</script>
